import { render, staticRenderFns } from "./AffCallbackTest.vue?vue&type=template&id=3f540d58&"
import script from "./AffCallbackTest.vue?vue&type=script&lang=js&"
export * from "./AffCallbackTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports